<template>
<svg class="cnm-icon" width="65" height="66" viewBox="0 0 65 66" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 23.2168L37 33.373L27 43.5293" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="64.5" y="65.373" width="64" height="64" transform="rotate(-180 64.5 65.373)" stroke="#B1B1B1"/>
</svg>
</template>
